import react from "react"
import { useSelector } from "react-redux";
import "./admin.css";
import { selectSessionId } from "./sessionSlice";

function Admin({children}){
      const sessionId = useSelector(selectSessionId);
      const isSuperadmin = sessionId === "admin";

      return <div className="admin-background">
       <div className="header-admin">
         <div className="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo" alt="Logo"/>{isSuperadmin && " SUPERADMIN"}
         </div>
         <div style={{ cursor: "pointer" }} onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL; }}>Learning Style</div>
         </div>

         <div className="user">
            <img src="/admin/user.png" alt="User"/>
         </div>
       </div>
       {children}
      </div>
}

export default Admin;
